export default "__VITE_ASSET__D$jq7rDu__"